<template>
  <div class="mod-list">
    <a-table :columns="columns" :data-source="dataBySort" row-key="index" :locale="locale" :pagination="data.pagination" :loading="loading" @change="onChange">
      <a slot="couponCode" slot-scope="text, record" @click.prevent="onShowDetail(record.couponCode)">{{ text }}</a>
      <span slot="type" slot-scope="text">{{ text | cardType }}</span>
      <span slot="preferentialType" slot-scope="text">{{ text | couponType }}</span>
      <span slot="preferentialValue" slot-scope="text, record">{{ record.preferentialType === 0 ? `${text}元` : `${text*10}折` }}</span>
      <span slot="maxAmount" slot-scope="text">{{ text }}元</span>
      <span slot="validity" slot-scope="text, record">{{ record.startDate }} - {{ text }}</span>
    </a-table>
  </div>
</template>

<script>
import { cardType, couponType } from '@/filters/coupon'
import _ from 'lodash'

const columns = [
  {
    dataIndex: 'indexNew',
    title: '序号',
    scopedSlots: { customRender: 'indexNew' }
  },
  {
    dataIndex: 'couponCode',
    title: '卡券号',
    scopedSlots: { customRender: 'couponCode' }
  },
  {
    dataIndex: 'type',
    title: '卡券类型',
    scopedSlots: { customRender: 'type' }
  },
  {
    dataIndex: 'preferentialType',
    title: '优惠类型',
    scopedSlots: { customRender: 'preferentialType' }
  },
  {
    dataIndex: 'preferentialValue',
    title: '面值',
    scopedSlots: { customRender: 'preferentialValue' }
  },
  {
    dataIndex: 'maxAmount',
    title: '最大优惠金额',
    scopedSlots: { customRender: 'maxAmount' }
  },
  {
    dataIndex: 'endDate',
    title: '优惠券有效期',
    scopedSlots: { customRender: 'validity' }
  }
]

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {
          list: [],
          pagination: {
            current: 1,
            pageSize: 10,
            total: 0
          }
        }
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dataBySort () {
      const list = _.orderBy(this.data.list, ['validEndDate', 'couponAmount'], ['asc', 'desc'])
      list.forEach((element, index) => {
        element.indexNew = index + 1
      })
      return list
    }
  },
  data () {
    return {
      columns,
      locale: {
        emptyText: '暂无数据'
      }
    }
  },
  methods: {
    onChange (pagination) {
      this.$emit('change', pagination)
    },
    onShowDetail (couponCode) {
      this.$emit('detail', couponCode)
    }
  },
  filters: {
    cardType,
    couponType
  }
}
</script>
